import React, { useEffect, useState } from "react";

import { ColorResult } from "react-color";

import { ElementState, Preview } from "@creatomate/preview";
import { BooleanField } from "@culturehq/components";

import { Trans } from "app/utils";
import general from "constants/general";
import ColorPicker from "../ColorPicker";
import getRgbColor from "../../utils/getRgbColor";
import getRgbObjFromString from "../../utils/getRgbObjFromString";
import getHexFromRgbObject from "../../utils/getHexFromRgbObject";
import getHslFromRgba from "../../utils/getHslFromRgba";
import { IMAGE_TYPE, VIDEO_TYPE } from "../../utils/constants";

interface ColorOverlayProps {
  activeElement: ElementState;
  preview: Preview;
}

const ColorOverlay: React.FC<ColorOverlayProps> = ({
  activeElement,
  preview
}) => {
  const [activeOverlayColor, setActiveOverlayColor] = useState(true);
  const [overlayColor, setOverlayColor] = useState<ColorResult>(general.DEFAULT_TRANSPARENT_COLOR);

  useEffect(
    () => {
      if (activeElement.source.type === VIDEO_TYPE || activeElement.source.type === IMAGE_TYPE) {
        const color = activeElement.source.color_overlay;
        if (!color) {
          setActiveOverlayColor(true);
        } else {
          const rgbaObj = getRgbObjFromString(color);
          setOverlayColor({
            hex: getHexFromRgbObject(rgbaObj),
            rgb: rgbaObj,
            hsl: getHslFromRgba(rgbaObj)
          });
          setActiveOverlayColor(false);
        }
      } else {
        setOverlayColor(general.DEFAULT_TRANSPARENT_COLOR);
        setActiveOverlayColor(true);
      }
    }, [activeElement]
  );

  const handleColorOverlayChange = async (color: ColorResult) => {
    setOverlayColor(color);
    await preview.applyModifications({
      [`${activeElement.source.id}.color_overlay`]: getRgbColor(color)
    });
  };

  const handleActiveOverlay = async (value: boolean) => {
    let color = null;
    if (value) {
      setOverlayColor(general.DEFAULT_TRANSPARENT_COLOR);
    } else {
      color = getRgbColor(overlayColor);
    }
    await preview.applyModifications({
      [`${activeElement.source.id}.color_overlay`]: color
    });
    setActiveOverlayColor(value);
  };

  return (
    <div className="chq-ffd">
      <span className="chq-ffd--lb"><Trans>Overlay Color</Trans></span>
      <div className="ColorOverlayField">
        <BooleanField
          className="boolean"
          onChange={handleActiveOverlay}
          name="activeOverlayColor"
          value={activeOverlayColor}
        >
          <Trans>None</Trans>
        </BooleanField>
        <ColorPicker
          disabled={activeOverlayColor}
          initialColor={overlayColor}
          onChangeColor={handleColorOverlayChange}
        />
      </div>
    </div>
  );
};

export default ColorOverlay;
